<template>
  <section class="min-h-[85vh] bg-white align-middle flex flex-col justify-center">
    <div class="max-w-screen mx-auto px-4 flex flex-wrap py-12 my-6 justify-center">
        <p >{{tr("_CancelText")}}</p>
    </div>
  </section>
</template>
<script>
export default {
  name: "ClosedText",
  computed: {
  },
  data() {
    return {};
  },
  components: {},
  methods: {
    tr(key) {
      return this.$root.tr(key);
    },
  },
};
</script>
